import { AgentService } from 'components/AgentService';
import styles from './index.module.scss';

/**
 * AgentServiceAppeal Props
 */
interface Props {
  /** エージェントサービスバナー表示フラグ */
  isShowAgentService: boolean;
}

/**
 * エージェントサービス登録訴求バナー
 *
 * @param {Props} props - コンポーネントのプロパティ
 * @param {boolean} props.isShowAgentService - エージェントサービスバナー表示フラグ
 * @returns {JSX.Element | null} JSX要素またはnull
 */
export const AgentServiceAppeal: React.FC<Props> = ({ isShowAgentService }) => {
  if (!isShowAgentService) return null;
  return (
    <div className={styles.careerRecommendJobList__agentServiceWrapper}>
      <AgentService href="/dcfront/member/memberRegist/?entry_id=1&carry_id=5100002287&carry_class=k" />
    </div>
  );
};
